import { Link } from "easy-page-router/react";

import { useHead } from "../services/common";
import { Footer, Header } from "../Layout";
import { LangSwitch } from "../components/Lang";
import { ThemeSwitch } from "../components/Theme";
import { useLang } from "../services/lang";
import { Page } from "../components";

export default function NotFound() {
    const { dict } = useLang();

    const title = dict.notFound + " | titimeme.com";
    useHead({ title, description: title });

    return <Page fixed={<>
        <Header>
            <LangSwitch />
            <ThemeSwitch />
        </Header>
        <Footer />
    </>}>

        <h1 style={{ marginTop: "200px" }}>{dict.notFound}</h1>
        <p style={{ marginTop: "50px" }}>
            <Link href={`/${dict.url}`}>{dict.backToHome}</Link>
        </p>

        <Footer />
    </Page>;
}
